import { api, ssoApi, uploadApi, apiFormData, apiConsole, apiVerify, wpApi } from '../creat-api'
export * from './program.js'
export * from './program-group-management.js'
export * from './releases.js'
export * from './transcode.js'
export * from './sdkApi.js'
export * from './dataAnalysis.js'
/**
 * 公共接口
 **/
// 分类接口
export function fetchDictionarys (params) {
  return apiVerify({
    url: '/dataDictionarys',
    params
  })
}
// VOD一级分类接口
export function fetchCommonCategoryInuse (params) {
  return api({
    url: '/commonCategoryInuse',
    params
  })
}
// 分类带二级分类
export function fetchSndCategory () {
  return api({
    url: '/sndCategory'
  })
}
// 获取分类与展示、必输字段接口
export function fetchCatalogItems (params) {
  return api({
    url: `/catalog/catalogItems/?category=${params.category}&type=${params.type}&platform=${params.platform}`
  })
}
// 获取用户信息
export function getUserInfo () {
  return ssoApi.get('/sso/user/authority/details')
}
// 添加专辑发布接口
export function fetchPushCommom (params) {
  return api({
    method: 'POST',
    url: '/programs/pushCommom',
    params
  })
}
// 退出
export function logout () {
  return ssoApi.get('/logout')
}

// 获取上传列表
const defaultParams = {
  status: '1000,0,2,1,4',
  limit: 100,
  page: 1
}
export function getUploadList (params = defaultParams) {
  return uploadApi.get('/api/v1/task', { params })
}
// 彻底删除上传列表
export function cancelUploadFile (fileId) {
  return uploadApi.post('/task/opera', {
    type: 5,
    ids: [fileId]
  })
}

/* 横竖海报上传 */
export function uploadWImg (params) {
  return apiFormData({
    method: 'POST',
    url: '/videoImgPaths/upload',
    dataType: 'JSON',
    processData: false,
    contentType: false, // 必须
    data: params
  })
}
// 海报长款校验
export function checkImg (params, type) {
  return apiFormData({
    method: 'POST',
    url: `/programSets/checkImg?type=${type}`,
    dataType: 'JSON',
    processData: false,
    contentType: false, // 必须
    data: params
  })
}
// 快传文件入库
export function fetchMaterial (params) {
  return api({
    method: 'POST',
    url: '/material',
    params
  })
}
// 版权列表
export function fetchCopyrights (params) {
  return api({
    url: '/copyrights',
    params
  })
}
// 取消绑定
export function fetchUnBindCopyrights (params) {
  return api({
    method: 'POST',
    url: '/unBindCopyrights',
    params
  })
}
// 超级管理员查询所有的商家帐户
export function getBusinessAccount (params) {
  return apiConsole.get('/subAccount/getBusinessAccount', params)
}

// 获取快传客户端下载地址
export function getDownloadUrl (platform) {
  return api.get(`/getUptoolClient/${platform}`)
}

// 获取快传SDK下载地址
export function getDownloadSDK (platform) {
  return api.get(`/getUptoolSDK/${platform}`)
}
// VOD下载EXCEL模版
export function fetchDownloadCos (params) {
  return api({
    url: '/downloadCos',
    params
  })
}
// CP服务 绑定网盘登录状态
export function checkWp () {
  return wpApi.get('/sso/user/authority/details')
}
